export enum LocaleLanguage {
    EN_US = 'en_US',
    SV_SE = 'sv_SE',
    NO_NO = 'no_NO',
    DA_DK = 'da_DK',
    FI_FI = 'fi_FI',
    DE_DE = 'de_DE',
    NL_NL = 'nl_NL',
    PL_PL = 'pl_PL',
    DEBUG = 'debug',
}

/** The languages a user can pick, in their own names. */
export const LOCALE_LANGUAGE_OPTIONS: { value: LocaleLanguage; name: string }[] = [
    { value: LocaleLanguage.DA_DK, name: 'Dansk' },
    { value: LocaleLanguage.DE_DE, name: 'Deutsch' },
    { value: LocaleLanguage.EN_US, name: 'English' },
    { value: LocaleLanguage.NL_NL, name: 'Nederlands' },
    { value: LocaleLanguage.NO_NO, name: 'Norsk' },
    { value: LocaleLanguage.PL_PL, name: 'Polski' },
    { value: LocaleLanguage.FI_FI, name: 'Suomi' },
    { value: LocaleLanguage.SV_SE, name: 'Svenska' },
];

export enum LocaleDateFormat {
    ISO = 'ISO',
    CENTRAL_EUROPE = 'CENTRAL_EUROPE',
    WESTERN_EUROPE = 'WESTERN_EUROPE',
    DUTCH = 'DUTCH',
    US = 'US',
}

export enum LocaleNumberFormat {
    ENGLISH = 'ENGLISH',
    EUROPEAN = 'EUROPEAN',
    ISO = 'ISO',
    SWISS = 'SWISS',
    INDIAN = 'INDIAN',
}

export type LocaleFormat = {
    language: LocaleLanguage;
    date: LocaleDateFormat;
    number: LocaleNumberFormat;
};

export const DEFAULT_LOCALE_FORMAT: LocaleFormat = {
    language: LocaleLanguage.EN_US,
    date: LocaleDateFormat.ISO,
    number: LocaleNumberFormat.ISO,
};
